module.exports = __webpack_public_path__ + "static/media/food-category.7e961399.png";